import appApi from '../../../../../api/app-api';

export const updatePasswordOperation = async (
  token: string,
  password: string,
): Promise<void> => {
  try {
    await appApi.updatePassword(token, password);
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
};
